/**
 * 문서 업로드 가능 확장자
 * @type {string[]}
 */
export const POSSIBLE_DOCUMENT_EXT = [
    'hwp', 'cell',
    'doc', 'docx',
    'xls', 'xlsx',
    'ppt', 'pptx', 'pdf', 'hwpx'
];

/**
 * 문서 업로드 가능 용량
 * @type {number}
 */
export const MAX_DOCUMENT_SIZE = 12 * 1024 * 1024;

/**
 * 문서 업로드 가능 기본 갯수
 * @type {number}
 */
export const MAX_DOCUMENT_DEFAULT_COUNT = 5;
